import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Breadcrumbs, Button, Typography, IconButton, } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import HomeIcon from "@mui/icons-material/Home";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useStoreFileViewerFolder } from "../../hooks/context";
var FolderOption = function (_a) {
    var folder = _a.folder, onClick = _a.onClick;
    return (_jsx(Button, { variant: "text", size: "small", sx: { minWidth: "fit-content", textTransform: "none" }, onClick: onClick, children: _jsx(Typography, { variant: "subtitle2", color: "textPrimary", children: folder }) }));
};
var FolderPath = function (_a) {
    var defaultHidden = _a.defaultHidden, virtualRoot = _a.virtualRoot;
    var theme = useTheme();
    var _b = useStoreFileViewerFolder(), folder = _b.folder, setFolder = _b.setFolder;
    var folders = folder.split("/").filter(function (f) { return !!f; });
    if (!!defaultHidden && !folders.length)
        return null;
    return (_jsx(Box, { children: _jsxs(Breadcrumbs, { separator: _jsx(NavigateNextIcon, { fontSize: "small" }), "aria-label": "breadcrumb", children: [_jsx(IconButton, { onClick: function () {
                        return setFolder(virtualRoot ? "/" + (folders[0] || "") : "/");
                    }, children: _jsx(HomeIcon, { fontSize: "small", color: "inherit", sx: { color: theme.palette.text.primary } }) }), folders.map(function (f, idx) {
                    return (_jsx(FolderOption, { folder: f, onClick: function () {
                            setFolder("/" + folders.slice(0, idx + 1).join("/"));
                        } }, "folder-".concat(idx)));
                })] }) }));
};
export default FolderPath;
